const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const AT = require("../../core/vault/ActionTypes");
const StoreUtil = require("../../../shared/StoreUtil");
const CopyTable = require("../data/CopyTable");
const displayNameErrorCopy = CopyTable.getFormInvalidCopy("displayName");
const redeemCodeCopy = CopyTable.getRedeemStudentLoggedOutStepCopy();

const styles = require("./styles/PageRedeemSubscription.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "RedeemSubscriptionStudentsLoggedOut",

		propTypes: {
			onContinue: PT.func.isRequired,
			onGoBack: PT.func.isRequired,
			cart: PT.object.isRequired,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		getInitialState: function() {
			return {
				newStudentName:
					this.props.cart.redeemSubscriptionStudentData?.name ?? "",
				nameError: null,
			};
		},

		// Update name and error states when name changes
		handleNameChange: function(e) {
			const newName = e.target.value;
			const nameError = StoreUtil.isBadNameInSubscriptions([newName], newName);
			this.setState({
				newStudentName: newName,
				nameError: nameError,
			});
		},

		// Saves subscription data in the vault and proceeds to the next step
		saveAndContinue: function() {
			if (this.state.newStudentName && !this.state.nameError) {
				// Update vault state only when submitting valid data
				this.props.dispatch({
					type: AT.UPDATE_REDEEM_CODES_STUDENT_DATA,
					studentData: {name: this.state.newStudentName},
				});
				this.props.onContinue();
			}
		},

		handleKeyDown: function(e) {
			if (e.key === "Enter") {
				e.preventDefault();
				this.saveAndContinue();
			}
		},

		render: function() {
			return (
				<div
					className={styles.sectionWrapper}
					onKeyDown={this.handleKeyDown}
					tabIndex="0"
				>
					<h2 className={styles.title}>{redeemCodeCopy.title}</h2>
					<div className={styles.bodyText}>{redeemCodeCopy.description}</div>
					<div className={styles.inputContainer}>
						<label className={styles.inputLabel} htmlFor="studentName">
							Student Name
						</label>
						<div className={styles.inputWrapper}>
							<input
								type="text"
								onChange={this.handleNameChange}
								name="studentName"
								placeholder="Name or nickname"
								value={this.state.newStudentName}
								required
								autoFocus
							/>
						</div>
						<div className={styles.statusMessage}>
							{this.state.newStudentName && this.state.nameError && (
								<div className={styles.errorMessage}>
									{displayNameErrorCopy[this.state.nameError]}
								</div>
							)}
						</div>
					</div>
					<div className={styles.buttonsContainer}>
						<button
							className={styles.secondaryButton}
							onClick={this.props.onGoBack}
						>
							Go Back
						</button>
						<button
							className={styles.primaryButton}
							onClick={this.saveAndContinue}
							disabled={!this.state.newStudentName || this.state.nameError}
						>
							Continue
						</button>
					</div>
				</div>
			);
		},
	})
);
